// src/pages/Society.jsx
import React from "react";
import { Link } from "react-router-dom";
import { useData } from "../context/DataProvider";

const Society = () => {
   const { articles, loading } = useData();

   if (loading) {
      return <div className="p-8">Жүктелуде...</div>;
   }

   // Фильтруем статьи, где CategoryID = "1" (Қоғам)
   const societyArticles = articles.filter((article) => article.CategoryID === "1");

   return (
      <div>
         {/* Шапка (Hero) */}
         <header className="relative bg-gray-900 text-white py-12 px-4 sm:px-6 lg:px-8 mb-8">
            <div
               className="absolute inset-0 bg-cover bg-center opacity-60"
               style={{
                  backgroundImage:
                     "url('https://images.unsplash.com/photo-1567662801789-1fbf291f4a52?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8c29jaWV0eXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=1400&q=60')",
               }}
            />
            <div className="relative max-w-5xl mx-auto">
               <h1 className="text-4xl sm:text-5xl font-bold mb-2">Қоғам</h1>
               <p className="text-lg text-gray-200 max-w-2xl">
                  Қазіргі әлеуметтік өмірімізге қатысты соңғы жаңалықтар мен сараптамалар осы жерде жинақталған. Әлеуметтік
                  мәселелер, қоғамдағы өзгерістер және адамдардың өзара байланысы туралы жазбаларды бізбен бірге бақылаңыз.
               </p>
            </div>
         </header>

         {/* Негізгі контент */}
         <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <section className="mb-8">
               <h2 className="text-2xl font-bold mb-4">Қош келдіңіздер!</h2>
               <p className="mb-4">
                  Бұл бөлімде сіздер әлеуметтік өмірдің сан алуан қырларын қамтыған жаңалықтар мен мақалаларды таба аласыздар.
                  Отбасылық құндылықтардан бастап еріктілер қозғалыстары мен қоғамдық ұйымдардың қызметіне дейін – қоғамдағы
                  маңызды оқиғалар мен бастамаларды назарларыңызға ұсынамыз.
               </p>
               <p>
                  Әлеуметтік жобалар, қайырымдылық шаралары мен мемлекеттік қолдау бағдарламалары туралы сұрақтарыңыз болса, осы
                  жерден қажетті мағлұмат алуыңызға болады. Біз қоғамдағы әр өзгерісті талдап, сараптап, оқырмандарымызға дәлелді
                  ақпарат беруді мақсат етеміз.
               </p>
            </section>

            {/* Сетка новостей (ID=1) */}
            <section>
               <h2 className="text-xl font-bold mb-4">Қоғам жаңалықтары</h2>

               {/* Если нет статей */}
               {societyArticles.length === 0 ? (
                  <p>Қоғам санатында жаңалықтар жоқ</p>
               ) : (
                  <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                     {societyArticles.map((article) => (
                        <SocietyCard key={article.ID} article={article} />
                     ))}
                  </div>
               )}
            </section>
         </main>
      </div>
   );
};

/* Карточка одной новости */
function SocietyCard({ article }) {
   const { ID, Title, Category, Date, ImageUrl } = article;

   return (
      <article className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
         <img
            src={ImageUrl || "https://via.placeholder.com/400x300"}
            alt={Title}
            className="w-full h-48 object-cover rounded-t-lg"
         />
         <div className="p-4">
            <p className="text-xs text-gray-500 mb-1">
               {Category} &mdash; {Date}
            </p>
            <h3 className="text-base font-semibold text-gray-800 mb-2 line-clamp-2">{Title}</h3>
            <Link to={`/news/${ID}`} className="text-sm text-blue-600 hover:underline">
               Толықтай оқу
            </Link>
         </div>
      </article>
   );
}

export default Society;
